import { CIcon } from '~/icons/types'
export const ciParkingP: CIcon = {
  name: 'parking-p',
  type: 'solid',
  width: 448,
  height: 512,
  paths: [
    {
      d:
        'M240 128h-96c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0 128h-48v-64h48c17.6 0 32 14.4 32 32s-14.4 32-32 32z',
      fill: 'currentColor'
    }
  ]
}
